import { z } from 'zod'

export function repositoryUrlHasUserInfo(value: string): boolean {
  try {
    const url = new URL(value)
    return Boolean(url.username || url.password)
  } catch {
    return false
  }
}

/** Removes credential- and cache-key-bearing URL parts before persistence or display. */
export function sanitizeRepositoryUrl(value: string): string {
  const url = new URL(value)
  url.username = ''
  url.password = ''
  url.search = ''
  url.hash = ''
  return url.toString().replace(/\/$/, value.endsWith('/') ? '/' : '')
}

export function sanitizeRepositoryUrlOrNull(value: string | null | undefined): string | null {
  if (!value) return null
  try {
    return sanitizeRepositoryUrl(value)
  } catch {
    return null
  }
}

export const repositoryUrlSchema = z
  .string()
  .url()
  .max(1000)
  .refine((value) => !repositoryUrlHasUserInfo(value), 'Repository URL must not contain user info')
